import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-portfolio',
  templateUrl: './portfolio.component.html',
  styleUrls: ['./portfolio.component.css'],
  standalone: false,
})
export class PortfolioComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
